module.exports = __webpack_public_path__ + "static/img/oterInfo.a13596ae.png";